import { createMatchSelector } from 'connected-react-router';
import { Map } from 'immutable';
import createSelector from 'web-app/util/custom-create-selector';
import StaffEntity from 'signin-app/entities/staff';
import { isPinApp } from 'signin-app/login/selectors';
import { pinLoginResponse } from 'signin-app/pin/selectors';
export const getEmployeeIdFromProps = (_, props) => {
    var _a;
    const { match, employeeId } = props;
    if (match) {
        return (_a = match.params) === null || _a === void 0 ? void 0 : _a.employeeId;
    }
    else if (employeeId) {
        return employeeId;
    }
    return '';
};
// Pin Employee selectors
export const pinEmployees = createSelector(pinLoginResponse, pinPeople => pinPeople && pinPeople.employees && pinPeople.employees.map(e => e.employee));
const employeeOverview = createSelector((state) => state.pin.people, getEmployeeIdFromProps, (pinPeople, employeeId) => {
    const employeeCheckinOverview = pinPeople && pinPeople.employees.find(employeeCheckin => employeeCheckin.employee.id === employeeId);
    return employeeCheckinOverview;
});
export const getPinEmployee = createSelector(employeeOverview, overview => {
    return overview && overview.employee;
});
export const makeGetAllEmployees = () => (staffEntityMap) => {
    return staffEntityMap.reduce((acc, mapItem) => {
        for (const employee of mapItem.employees) {
            const extendedEmployee = {
                ...employee,
                staffGroupId: mapItem.groupId,
            };
            acc = acc.set(employee.id, extendedEmployee);
        }
        return acc;
    }, Map());
};
const getAllEmployees = makeGetAllEmployees();
export const makeEmployeeName = () => createSelector(isPinApp, StaffEntity.selectors.entityMap, getPinEmployee, getEmployeeIdFromProps, (pinApp, staffEntityMap, pinEmployee, employeeId) => {
    if (pinApp) {
        return pinEmployee ? pinEmployee.name.fullName : '';
    }
    const allEmployees = getAllEmployees(staffEntityMap);
    const employee = allEmployees.find(employee => employee.id === employeeId);
    return employee ? employee.name.fullName : '';
});
export const makeStaffSelector = (routePath) => createSelector(StaffEntity.selectors.entityMap, createMatchSelector(routePath), (staffEntityMap, match) => {
    if (!match) {
        return null;
    }
    const { employeeId } = match.params;
    let employee;
    for (const staffGroup of staffEntityMap) {
        employee = staffGroup[1].employees.find((employee) => employee.id === employeeId);
        if (employee) {
            break;
        }
    }
    return employee;
});
